import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchGitPullRequests } from '@/services/git/api';
import type { GitPullRequest } from '@/services/git/types';
import { useAuthStoreV1 } from '@/stores/authStore_v1';

export function useGitPullRequests(
  repoFullName: string | null | undefined,
  state: 'open' | 'closed' | 'all' = 'open',
): UseQueryResult<GitPullRequest[], Error> {
  const token = useAuthStoreV1((s) => s.token);
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id);

  return useQuery({
    queryKey: ['gitPullRequests', orgId, repoFullName, state],
    queryFn: () => fetchGitPullRequests(orgId!, repoFullName!, state),
    enabled: !!token && !!orgId && !!repoFullName,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
    meta: { silent: true },
  });
}
